module.exports = __webpack_public_path__ + "img/07_DSC7876-min.2e1e71ea.jpg";